module.exports = __webpack_public_path__ + "img/xbody-asset-1.5e6551e4.svg";